import i18n from '@/utils/i18n';
const fields = [
    {
        name: "slug",
        type: "text",
        label: i18n.t('wallkit_pricing.fields.slug')
    },
    {
        name: "title",
        type: "text",
        required: true,
        label: i18n.t('wallkit_pricing.fields.title')
    },
    {
        name: "description",
        type: "textarea",
        required: true,
        label: i18n.t('wallkit_pricing.fields.description')
    },
    {
        name: "monthly_price",
        type: "price",
        required: true,
        currency: false,
        label: i18n.t('wallkit_pricing.fields.monthly_price')
    },
    {
        name: "transaction_fee",
        type: "number",
        required: true,
        step: 0.01,
        min: 0,
        max: 100,
        label: i18n.t('wallkit_pricing.fields.transaction_fee')
    },
    {
        name: "free_signups",
        type: "number",
        required: true,
        min: 0,
        label: i18n.t('wallkit_pricing.fields.free_signups')
    },
    {
        name: "up_free_signups",
        type: "number",
        required: true,
        min: 0,
        label: i18n.t('wallkit_pricing.fields.up_free_signups')
    },
    {
        name: "up_free_signups_price",
        type: "price",
        required: true,
        currency: false,
        label: i18n.t('wallkit_pricing.fields.up_free_signups_price')
    },
    {
        name: "free_support_hours",
        type: "number",
        required: true,
        min: 0,
        label: i18n.t('wallkit_pricing.fields.free_support_hours')
    },
    {
        name: "up_free_support_price_per_hour",
        type: "price",
        required: true,
        currency: false,
        label: i18n.t('wallkit_pricing.fields.up_free_support_price_per_hour')
    },
    {
        name: "available_paywall",
        type: "switch",
        label: i18n.t('wallkit_pricing.fields.available_paywall'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no')
    },
    {
        name: "available_ti_event",
        type: "switch",
        label: i18n.t('wallkit_pricing.fields.available_ti_event'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no')
    },
    {
        name: "available_reader_id",
        type: "switch",
        label: i18n.t('wallkit_pricing.fields.available_reader_id'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no')
    },
    {
        name: "active",
        type: "switch",
        label: i18n.t('wallkit_pricing.fields.active'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no')
    },
    {
        name: "is_public",
        type: "switch",
        label: i18n.t('wallkit_pricing.fields.is_public'),
        title: i18n.t('global.yes'),
        titleFalse: i18n.t('global.no')
    }
]
export default fields
